import React from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";
import {
  IoIosArrowForward,
  IoIosTime,
  IoIosTrendingUp,
  IoIosTrendingDown,
} from "react-icons/io";
import { FormatNumber, FormatDate } from "../../helpers";

const RecentTransactions = (props) => {
  const { data, error } = useSWR("/transaction?limit=5");
  const items = (data && data.content) || [];

  return (
    <section className="home-recent">
      <header className="home-recent__header">
        <span className="home-recent__title">
          <IoIosTime /> Transaksi Terbaru
        </span>
        <Link to="/transaction" className="home-recent__more">
          Lihat semua <IoIosArrowForward />
        </Link>
      </header>
      {!data && !error && (
        <div className="home-recent__empty">Memuat…</div>
      )}
      {data && items.length === 0 && (
        <div className="home-recent__empty">
          Belum ada transaksi. Tap <strong>+</strong> untuk catat yang pertama.
        </div>
      )}
      <ul className="home-recent__list" style={{ listStyle: "none" }}>
        {items.map((t) => {
          const isIn = t.amount >= 0;
          return (
            <Link
              to="#"
              key={t.id}
              className="home-recent__item"
              onClick={(e) => {
                e.preventDefault();
                localStorage.setItem("cashflow", JSON.stringify(t));
                props.history && props.history.push("/transaction/edit/" + t.id);
              }}
            >
              <span
                className={`home-recent__icon home-recent__icon--${
                  isIn ? "in" : "out"
                }`}
              >
                {isIn ? <IoIosTrendingUp /> : <IoIosTrendingDown />}
              </span>
              <div className="home-recent__body">
                <div className="home-recent__desc">
                  {t.description || (isIn ? "Pemasukan" : "Pengeluaran")}
                </div>
                <div className="home-recent__meta">
                  {FormatDate(t.date)} · {t.wallet && t.wallet.name}
                </div>
              </div>
              <span
                className={`home-recent__amount home-recent__amount--${
                  isIn ? "in" : "out"
                }`}
              >
                {isIn ? "+" : "−"}Rp {FormatNumber(Math.abs(Math.round(t.amount)))}
              </span>
            </Link>
          );
        })}
      </ul>
    </section>
  );
};

export default RecentTransactions;
